// Legacy invoices may omit optional totals or store them as numbers.
// Keep unknown amounts blank in the list/export rather than inventing a value.
export const invoiceAmountText = value => {
  if (typeof value !== 'number' && typeof value !== 'string') return ''
  const text = String(value).replace(/,/g, '').trim()
  return text !== '' && Number.isFinite(Number(text)) ? text : ''
}

export const invoiceAmountNumber = value => Number(invoiceAmountText(
  typeof value === 'string' ? value.replace(/\s*%$/, '') : value,
))
